module.exports = __webpack_public_path__ + "static/media/magnifyGlass.f8d0d1c4.svg";